export const metricCategory = {
  STARTUP: 'Startup Experience',
  PLAYBACK: 'Playback Experience',
  ENGAGEMENT: 'Audience and Engagement',
  ADEXP: 'Ad Experience',
  SP: 'SPI and KPI Metrics',
};

export const metricCategoryOrder = ['ENGAGEMENT', 'SP', 'STARTUP', 'PLAYBACK', 'ADEXP'];
